module.exports = __webpack_public_path__ + "static/media/acc.4135b690.png";